/* ============================================================
   VIDEOWAND · Lieblingscap

   Spielt nur ab, was gerade sichtbar ist. Bei fuenf Kacheln
   wuerden sonst fuenf Videos gleichzeitig laufen - das kostet
   Akku, Datenvolumen und Rechenleistung, besonders am Handy.

   Der Pause-Knopf setzt eine Handsperre: Ein von Hand
   angehaltenes Video startet auch beim Scrollen nicht wieder.

   Ohne Verbindung zu Shopifys Warenkorb- oder Varianten-
   Mechanik: dieses Skript fasst nur die eigenen Kacheln an.
   ============================================================ */
(function () {
  'use strict';

  var LEISER_MODUS = window.matchMedia
    ? window.matchMedia('(prefers-reduced-motion: reduce)').matches
    : false;

  function spiele(video) {
    var versuch = video.play();
    if (versuch && versuch.catch) { versuch.catch(function () {}); }
  }

  function starte(bereich) {
    (bereich || document).querySelectorAll('[data-lc-vw]').forEach(function (wand) {
      if (wand.dataset.lcBereit === '1') return;
      wand.dataset.lcBereit = '1';

      var automatisch = wand.dataset.lcAuto === 'true' && !LEISER_MODUS;
      var kacheln = wand.querySelectorAll('[data-lc-vw-kachel]');

      kacheln.forEach(function (kachel) {
        var video = kachel.querySelector('video');
        var knopf = kachel.querySelector('[data-lc-vw-pause]');
        if (!video) {
          if (knopf) { knopf.remove(); }
          return;
        }

        if (!automatisch) {
          kachel.classList.add('steht');
        }

        if (knopf) {
          knopf.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            if (kachel.classList.contains('steht')) {
              kachel.classList.remove('steht');
              kachel.dataset.lcHandsperre = '';
              spiele(video);
            } else {
              kachel.classList.add('steht');
              kachel.dataset.lcHandsperre = '1';
              video.pause();
            }
          });
        }
      });

      if (!automatisch || !('IntersectionObserver' in window)) return;

      var beobachter = new IntersectionObserver(
        function (eintraege) {
          eintraege.forEach(function (eintrag) {
            var kachel = eintrag.target;
            var video = kachel.querySelector('video');
            if (!video) return;

            if (eintrag.isIntersecting) {
              if (kachel.dataset.lcHandsperre === '1') return;
              kachel.classList.remove('steht');
              spiele(video);
            } else {
              video.pause();
            }
          });
        },
        { threshold: 0.5 }
      );

      kacheln.forEach(function (kachel) {
        if (kachel.querySelector('video')) { beobachter.observe(kachel); }
      });
    });
  }

  starte();

  /* Im Theme-Editor wird der Abschnitt bei jeder Aenderung neu geladen */
  document.addEventListener('shopify:section:load', function (e) {
    starte(e.target);
  });
})();